import { render, staticRenderFns } from "./ProfitBlock.vue?vue&type=template&id=aebeb76a&"
import script from "./ProfitBlock.vue?vue&type=script&lang=js&"
export * from "./ProfitBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports